'use client'

import { useCallback } from 'react'

interface ShareButtonProps {
  title: string
  href: string
  description?: string
}

const buildXShareUrl = (title: string, url: string, description?: string) => {
  const text = description ? `${title} — ${description}` : title
  const params = new URLSearchParams({
    text,
    url
  })
  return `https://twitter.com/intent/tweet?${params.toString()}`
}

export const ShareButton = ({ title, href, description }: ShareButtonProps) => {
  const handleShare = useCallback(() => {
    const absoluteUrl = new URL(href, window.location.origin).toString()
    const shareData = { title, text: description ?? title, url: absoluteUrl }

    if (typeof navigator.share === 'function') {
      void navigator.share(shareData)
      return
    }

    const xUrl = buildXShareUrl(title, absoluteUrl, description)
    window.open(xUrl, '_blank', 'noopener,noreferrer')
  }, [description, href, title])

  return (
    <button
      type="button"
      className="rounded-full border border-[color:var(--accent)] px-4 py-2 text-sm font-semibold text-[color:var(--accent)] transition hover:bg-[rgba(37,99,235,0.12)]"
      aria-label={`${title}をシェア`}
      onClick={handleShare}
    >
      シェア
    </button>
  )
}
